import React from "react";
import { IPlanningViewsGroup, PlanningViewBy } from "../types";
import Tiles from "./Tiles";

interface Props {
  group: IPlanningViewsGroup;
  viewBy: PlanningViewBy;
  shownSprintDetails?: boolean;
  isActive: boolean;
  onTileClick?: () => void;
}
const RenderTiles: React.FC<Props> = ({
  group,
  viewBy,
  shownSprintDetails,
  isActive,
  onTileClick,
}) => {
  return (
    <Tiles
      isActive={isActive}
      viewBy={viewBy}
      group={group}
      shownSprintDetails={shownSprintDetails}
      onTileClick={onTileClick}
    />
  );
};

export default RenderTiles;
